import api from '@/api'

const namespaced = true

const state = {
  selectedMenus: null,
  availableMenus: null,
  icon: null
}

const getters = {
  selectedMenus: state => state.selectedMenus,
  availableMenus: state => state.availableMenus,
  icon: state => state.icon
}

const mutations = {
  SET_SELECTED_MENUS: (state, payload) => {
    state.selectedMenus = payload
  },
  SET_AVAILABLE_MENUS: (state, payload) => {
    state.availableMenus = payload
  },
  SET_ICON: (state, payload) => {
    state.icon = payload
  }
}

const actions = {
  async getSelectedMenus({ commit }) {
    try {
      const { data } = await api.getMenuConfigurations()
      if(data.error) {
        commit('SET_SELECTED_MENUS', [])
        return
      }

      commit('SET_SELECTED_MENUS', data)
    } catch (err) {
      throw err
    }
  },
  async getAvailableMenus({ commit }) {
    try {
      const { data } = await api.getMenuFeatures()
      if(data.error) {
        commit('SET_AVAILABLE_MENUS', [])
        return
      }
      commit('SET_AVAILABLE_MENUS', data)
    } catch (err) {
      throw err
    }
  },
  async uploadMenuIcon({ commit }, payload) {
    try {
      const formData = new FormData()
      formData.append('attachment', payload.file)
      const { data } = await api.uploadMenuIcon(formData)
      return data
    } catch (error) {
      throw error
    }
  },
  async updateMenuConfiguration({}, payload) {
    try {
      return await api.putMenuConfiguration(payload)
    } catch (error) {
      throw error
    }
  }
}

export default { namespaced, state, getters, mutations, actions }